import { render, staticRenderFns } from "./homeZone.vue?vue&type=template&id=1dda08ef&scoped=true&"
import script from "./homeZone.vue?vue&type=script&lang=ts&"
export * from "./homeZone.vue?vue&type=script&lang=ts&"
import style0 from "./homeZone.vue?vue&type=style&index=0&id=1dda08ef&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dda08ef",
  null
  
)

export default component.exports